import { ICopyLinkedValuesBehavior } from "./ICopyLinkedValuesBehavior";

export interface ICopyLinkedTextsBehaviorSpecifiable {
  copyLinkedTextsBehavior: ICopyLinkedValuesBehavior;
}

export function instanceOfICopyLinkedTextsBehaviorSpecifiable(instance: any): instance is ICopyLinkedTextsBehaviorSpecifiable {
  return instance
      && (instance.copyLinkedTextsBehavior !== undefined);
}
